import ColumnConfig from "@viz-ui/models/tableConfig/columnConfig";

angular
  .module("acl.visualizer.model.tableConfig", ["acl.visualizer.model.model"])
  .factory("ColumnConfig", () => ColumnConfig);
